<template>
    <div class="app-footer" :class="footerClasses">
        <layout-contained>
            <div class="py-6 leading-7">
                <span class="text-gray-100">
                    &copy; {{ new Date().getFullYear() }}
                    {{ $config.public.companyNameLong }}
                    <span>
                        | <NuxtLink class="hover:underline" to="/blog">Blog</NuxtLink> |
                        <NuxtLink class="hover:underline" to="/venue">Venue</NuxtLink> |
                        <NuxtLink class="hover:underline" to="/music">Music</NuxtLink> |
                        <NuxtLink class="hover:underline" to="/faqs">FAQs</NuxtLink> |
                        <NuxtLink class="hover:underline" to="/contact">Contact</NuxtLink> |
                        <NuxtLink class="hover:underline" to="/event-terms">Event Terms</NuxtLink> |
                        <NuxtLink class="hover:underline" to="/website-terms">Website Terms</NuxtLink> |
                        <NuxtLink class="hover:underline" to="/privacy">Privacy</NuxtLink> |
                        <NuxtLink class="hover:underline" to="/cookies">Cookies</NuxtLink>
                    </span>
                </span>
            </div>
        </layout-contained>
    </div>
</template>

<script>
export default {
    name: 'AppFooter',
    props: {
        color: {
            required: false,
            type: String,
            default: 'bg-zinc-800',
        },
    },
    computed: {
        footerClasses() {
            const cls = {};
            cls[this.color] = true;
            return cls;
        },
    },
};
</script>
